var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatabaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "database_icon",
    d: "M16,14.889a16.451,16.451,0,0,1-7.236-1.361Q6,12.167,6,10.444q0-1.75,2.764-3.1A16.6,16.6,0,0,1,16,6a16.6,16.6,0,0,1,7.236,1.347Q26,8.694,26,10.444q0,1.722-2.764,3.083A16.451,16.451,0,0,1,16,14.889Zm0,5.556a18.415,18.415,0,0,1-7.028-1.222Q6,18,6,16.278V13.5a2.311,2.311,0,0,0,1.042,1.875,8.88,8.88,0,0,0,2.583,1.306,18.028,18.028,0,0,0,3.278.75,23.248,23.248,0,0,0,3.1.236,23.109,23.109,0,0,0,3.111-.236,18.868,18.868,0,0,0,3.264-.736A8.644,8.644,0,0,0,24.958,15.4,2.333,2.333,0,0,0,26,13.5v2.778Q26,18,23.028,19.222A18.415,18.415,0,0,1,16,20.444ZM16,26a18.415,18.415,0,0,1-7.028-1.222Q6,23.556,6,21.833V19.056a2.311,2.311,0,0,0,1.042,1.875,8.88,8.88,0,0,0,2.583,1.306,18.028,18.028,0,0,0,3.278.75,23.248,23.248,0,0,0,3.1.236,23.109,23.109,0,0,0,3.111-.236,18.868,18.868,0,0,0,3.264-.736,8.644,8.644,0,0,0,2.583-1.292A2.333,2.333,0,0,0,26,19.056v2.778q0,1.722-2.972,2.944A18.415,18.415,0,0,1,16,26Z",
    transform: "translate(-6 -6)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/database_icon.5fdb60b7befed3346c349ec4dccee303.svg";
export { ForwardRef as ReactComponent };